export enum VatRate {

  // Hocher MwSt. Satz // standard (high) vat rate
  STANDARD = 'STANDARD',
  // Niedriger MwSt. Satz // reduced (low) vat rate
  REDUCED = 'REDUCED',
  // Niedriger MwSt. Satz // reduced (low) vat rate
  REDUCED2 = 'REDUCED2',
  // Niedriger MwSt. Satz // super reduced (low) vat rate
  SUPER_REDUCED = 'SUPER_REDUCED',
  // Durchlaufender Posten
  TRANSIT = 'TRANSIT',
  // Vorübergehender MwSt. Satz // temporary vat rate
  TEMPORARY = 'TEMPORARY',
  // Altteilsteuer // Required Feature 'OLD_PART'
  OLD_PART_STANDARD = 'OLD_PART_STANDARD',
  // Altteilsteuer Gutschrift z.B. Land- und Forstwirtschaft nacho § 24
  // Required Feature 'OLD_PART'
  OLD_PART_CREDIT = 'OLD_PART_CREDIT',
  // Individueller Steuersatz, der Wert muss direkt verwendet werden.
  // Individueller Steuersatz darf im FE nicht angezeigt werden
  INDIVIDUAL = 'INDIVIDUAL',
}
